function getConditionalRoutes() {
  const idPerfil = window.sessionStorage.getItem("idPerfil");
  const routes = [];

  if (!idPerfil) {
    return routes;
  }
/*
  if (idPerfil === "5" || idPerfil === "0") {
    routes.push({
      path: '/persona',
      name: 'Personas',
      component: () => import('@/views/forms/Persona.vue'),
      meta: { title: 'Gestión de Pacientes' }
    });
  }

  if (idPerfil === "5" || idPerfil === "0") {
    routes.push({
      path: '/medico',
      name: 'Médicos',
      component: () => import('@/views/forms/Medico.vue'),
      meta: { title: 'Registro de Médicos' }
    });
  }

  if (["5", "0", "0"].includes(idPerfil)) {
    routes.push({
      path: '/usuario',
      name: 'Usuarios',
      component: () => import('@/views/forms/Usuario.vue'),
    });
  }
*/
  if (idPerfil === "5" || idPerfil === "0") {
    routes.push({
      path: '/aviso',
      name: 'Avisos',
      component: () => import('@/views/forms/Aviso.vue'),
      meta: { title: 'Registro de Avisos' }
    });
  }

  return routes;
}

const baseRoutes = [
  {
    path: '/cita',
    name: 'Citas/Admisión',
    component: () => import('@/views/forms/Cita.vue'),
    meta: { title: 'Citas/Admisión' }
  },
  {
    path: '/atencion',
    name: 'Atenciones',
    component: () => import('@/views/forms/Atencion.vue'),
    meta: { title: 'Atenciones' }
  },
  {
    path: '/interconsulta',
    name: 'Interconsultas',
    component: () => import('@/views/forms/Interconsulta.vue'),
    meta: { title: 'Interconsultas' }
  },
  {
    path: '/referencia',
    name: 'Referencias y Derivaciones',
    component: () => import('@/views/forms/Referencia.vue'),
    meta: { title: 'Referencias y Derivaciones' }
  }
];

const routes = baseRoutes.concat(getConditionalRoutes());

export { routes };